import type { LetterSenderSlice } from '../types';

export interface SignOffDefaults {
  signOff: string;
  signature: string;
  useOnFutureLetters: boolean;
}

export interface SignOffState {
  isSignOffModalOpen: boolean;
  signOff: string;
  signature: string;
  appliedSignature: string;
  useOnFutureLetters: boolean;
  signOffDefaults: SignOffDefaults;
}

export const signOffInitialState = {
  isSignOffModalOpen: false,
  signOff: '',
  signature: '',
  appliedSignature: '',
  useOnFutureLetters: false,
  signOffDefaults: {
    signOff: '',
    signature: '',
    useOnFutureLetters: false,
  },
} satisfies SignOffState;

export type SignOffActions = {
  setIsSignOffModalOpen: (isOpen: boolean) => void;
  setSignOff: (signOff: string) => void;
  setSignature: (signature: string) => void;
  setAppliedSignature: (appliedSignature: string) => void;
  setUseOnFutureLetters: (useOnFutureLetters: boolean) => void;
  setSignOffDefaults: (defaults: SignOffDefaults) => void;
};

export const createSignOffSlice: LetterSenderSlice<SignOffActions> = (set) => ({
  setIsSignOffModalOpen: (isSignOffModalOpen) => set({ isSignOffModalOpen }),
  setSignOff: (signOff) => set({ signOff }),
  setSignature: (signature) => set({ signature }),
  setAppliedSignature: (appliedSignature) => set({ appliedSignature }),
  setUseOnFutureLetters: (useOnFutureLetters) => set({ useOnFutureLetters }),
  setSignOffDefaults: (signOffDefaults) => set({ signOffDefaults }),
});
